import React from 'react';
import StickyNoteComponent from 'components/StickyNoteComponent';

export const StickyNoteModalComponent = ({ canvasSVGObject }) => {
    return (
        <StickyNoteComponent canvasSVGObject={canvasSVGObject} />
    )
};
